import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../services/Firebase";
import { loginUser } from "../../services/api";
import { setAuth, logout, setLoading } from "./authSlice";
import { showError } from "../../utils/toast";

export const initAuthListener = () => (dispatch) => {
  dispatch(setLoading(true));

  return onAuthStateChanged(auth, async (currentUser) => {
    // ❌ User logged out
    if (!currentUser) {
      dispatch(logout()); // sets loading = false internally
      return;
    }

    // ❌ Email not verified
    if (!currentUser.emailVerified) {
      showError("Please verify your email and login again.");
      dispatch(logout()); // ✅ IMPORTANT
      return;
    }

    const storedUser = localStorage.getItem("user");
    const storedToken = localStorage.getItem("accessToken");

    // ✅ Restore from localStorage
    if (storedUser && storedUser !== "undefined" && storedToken) {
      try {
        dispatch(
          setAuth({
            user: JSON.parse(storedUser),
            accessToken: storedToken,
          })
        );
        return; // loading already false via setAuth
      } catch (e) {
        console.error("Failed to parse stored user", e);
        localStorage.removeItem("user");
        localStorage.removeItem("accessToken");
      }
    }

    try {
      const idToken = await currentUser.getIdToken();
      const res = await loginUser(idToken);

      localStorage.setItem("user", JSON.stringify(res.data.user));
      localStorage.setItem("accessToken", res.data.accessToken);

      dispatch(
        setAuth({
          user: res.data.user,
          accessToken: res.data.accessToken,
        })
      );
      // ✅ DO NOT call setLoading(false) here
    } catch (err) {
      console.error("Login failed", err);
      dispatch(logout()); // ensures loading=false + clean state
    }
  });
};